export default __webpack_public_path__ + "static/media/gene-by-gene-logo.f93181e9.png";